<template>
  <div style="padding: 10px 10px 10px 0">
    <div>
      <el-form :inline="true" :model="tcSelect" ref="tcSelect">
        <el-form-item label="时间：">
          <el-date-picker
            size="small"
            placeholder="选择入场日期"
            value-format="yyyy-MM-dd"
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          >
            <!-- :picker-options="pickerOptions" -->
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="dc()">导出</el-button>
        </el-form-item>
        <el-form-item>
          <span>实际到账总金额：{{ sjSumAmount }}</span>
        </el-form-item>
        <el-form-item>
          <span>月租车总金额：{{ tingcheAmount }}</span>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tcList" style="width: 100%" v-loading="loading">
      <el-table-column prop="time" label="所属日期" align="center"></el-table-column>
      <el-table-column
        prop="wechatAmount"
        label="微信实收金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="wechatbalance"
        label="微信实际到账金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="aliPay"
        label="支付宝实收金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="aliBalance"
        label="支付宝实际到账金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ysBalance"
        label="微信支付宝实际到账金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="微信支付宝实收金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ktAmount"
        label="科拓系统应收金额"
        align="center"
      ></el-table-column>
      <el-table-column prop="balance" label="差额" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="setRow(scope.row)">情况说明</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tcSelect.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      style="margin-top: 10px"
    >
    </el-pagination>

    <el-dialog title="情况说明" :visible.sync="rentTypShow" width="1000px">
      <!-- <div style="margin-bottom: 10px;">
			<div>订单ID：{{ formRent.orderId }}</div>
			</div> -->
      <div>
        <el-form :inline="true" :model="formRent" class="demo-form-inline">
          <el-form-item label="订单时间：">
            <el-date-picker
              size="small"
              v-model="formRent.orderTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车牌号：">
            <el-input
              size="small"
              v-model="formRent.carNum"
              placeholder="请输入车牌号"
            ></el-input>
          </el-form-item>
          <el-form-item label="金额：">
            <el-input
              size="small"
              v-model="formRent.money"
              placeholder="请输入金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="事由：">
            <el-input
              size="small"
              v-model="formRent.particulars"
              placeholder="请输入事由"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              size="small"
              v-model="formRent.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件上传">
            <el-upload
              class="upload-demo"
              action="/api/admin/dutyInfo/uploadFile"
              name="file"
              :headers="headerData"
              :on-success="onSuccess"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>

            <div
              v-for="(item, index) in fileList"
              :key="index"
              style="
                color: #3c98ff;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
              "
            >
              <div @click="down(item)">{{ item }}</div>
              <div @click="delUrl(index)"><i class="el-icon-delete"></i></div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              style="margin-left: 50px"
              size="small"
              type="primary"
              @click="rentSubmit()"
              >保存</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              style="margin-left: 10px"
              size="small"
              type="primary"
              @click="resetRent()"
              >重置</el-button
            >
          </el-form-item>
          <!-- <div style="width:100%;text-align: center;">
					</div> -->
        </el-form>
      </div>

      <!-- <div>合计：<span style="font-size: 20px;">{{sum}}</span>（元）</div> -->
      <el-table
        :data="historyData"
        style="width: 100%"
        show-summary
        :summary-method="totalOutYear"
        max-height="400"
      >
        <el-table-column prop="order_time" label="订单时间" align="center" />
        <el-table-column prop="car_num" label="车牌号" align="center" />
        <el-table-column prop="money" label="金额" align="center" />
        <el-table-column prop="particulars" label="事由" align="center" />
        <el-table-column prop="remark" label="备注" align="center" />
        <el-table-column prop="fileUrl" label="附件" align="center" width="350">
          <template slot-scope="scope">
            <div
              @click="down(item)"
              v-for="item in scope.row.fileList"
              style="color: #3c98ff; cursor: pointer"
            >
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="editRentType(scope.$index, scope.row)"
              type="text"
              size="text"
            >
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="rentTypShow = false">取 消</el-button> -->
        <el-button @click="rentTypShow = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
export default {
  data() {
    return {
      sjSumAmount: 0,
      tingcheAmount: 0,
      historyData: [],
      headerData: {
        Authorization: localStorage.access_token,
      },
      oldFormRent: {
        id: "",
        orderId: "", //订单ID
        orderTime: "", //订单时间
        carNum: "", //车牌号
        money: "", //金额
        particulars: "", //事由
        remark: "", //备注
        fileUrl: "", //图片路径
      },
      formRent: {
        id: "",
        orderId: "", //订单ID
        orderTime: "", //订单时间
        carNum: "", //车牌号
        money: "", //金额
        particulars: "", //事由
        remark: "", //备注
        fileUrl: "", //图片路径
      },
      fileList: [],
      rentTypShow: false,
      loading: false,
      dateArr: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      tcSelect: {
        startTime: null,
        endTime: null,
        parkingLot: null,
        carNum: null,
        currentPage: 1,
        pageSize: 10,
      },
      oldtcSelect: {},
      sum: 0,
      tcList: [],
      headerData: {
        Authorization: localStorage.access_token,
      },
      activeName: "2",
      form: {
        //表单数据
        name: "",
        age: "",
      },
      oldForm: undefined, //表单备份数据
      data: [], //表格数据
      show: false, //控制弹窗
      title: "",
      disable: false, //节流
      yzlist: [],
      isChange: false,
    };
  },
  methods: {
    totalOutYear(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "money") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      return sums;
    },

    editRentType(index, row) {
      this.fileList = [];
      this.formRent.id = row.id; //订单ID
      this.formRent.orderId = row.orderId; //订单ID
      this.formRent.orderTime = row.order_time; //订单时间
      this.formRent.carNum = row.car_num; //车牌号
      this.formRent.money = row.money; //金额
      this.formRent.particulars = row.particulars; //事由
      this.formRent.remark = row.remark; //备注
      this.formRent.fileUrl = row.file_url; //图片路径
      if (row.file_url) this.fileList = row.file_url.split(",");
    },
    resetRent() {
      this.fileList = [];
      this.formRent = JSON.parse(JSON.stringify(this.oldFormRent));
    },
    rentSubmit() {
      if (this.formRent.orderTime == "") {
        this.$message.error("请选择订单时间");
        return;
      }
      if (this.formRent.carNum == "") {
        this.$message.error("请输入车牌号");
        return;
      }
      if (this.formRent.money == "") {
        this.$message.error("请输入金额");
        return;
      }
      // if (this.formRent.particulars == "") {
      //   this.$message.error("请输入事由");
      //   return;
      // }
      let arr = [];
      this.fileList.forEach((element) => {
        arr.push(element);
      });
      this.formRent.fileUrl = arr.toString();
      let url = "/api/bdTingCheOrder/insertPresentation";
      if (this.formRent.id) {
        url = "/api/bdTingCheOrder/updateQk";
      }
      this.$http.post(url, this.formRent).then((res) => {
        if (res.data.code == 0) {
          this.$message.success("保存成功");
          this.getHistory();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onSuccess(response, file, fileList) {
      if (response.code == "0") {
        // this.fileList.push({
        //   name: file.name.split(".")[0],
        //   url: response.data,
        // });
        this.fileList.push(response.data);
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },
    setRow(row) {
      // this.resetForm();
      // this.getList();//
      this.formRent = {
        orderId: row.id, //订单ID
        orderTime: "", //订单时间
        carNum: "", //车牌号
        money: "", //金额
        particulars: "", //事由
        remark: "", //备注
        fileUrl: "", //图片路径
      };
      this.fileList = [];
      this.getHistory();
      this.rentTypShow = true;
    },
    getHistory() {
      this.$http
        .get("/api/bdTingCheOrder/getPresentation?id=" + this.formRent.orderId)
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.items.forEach((element) => {
              element.order_time = element.order_time.split("T")[0];
              if (element.file_url) {
                element.fileList = element.file_url.split(",");
              }
            });
            this.sum = res.data.data.sum;
            this.historyData = res.data.data.items;
          } else {
            this.historyData = [];
          }
        });
    },
    down(url) {
      window.open(url);
    },
    delUrl(index) {
      this.fileList.splice(index, 1);
    },
    dc() {
      publicExport(
        "/api/bdTingCheOrder/exportTingcheStatement",
        {
          startTime: this.dateArr[0],
          endTime: this.dateArr[1],
          currentPage: this.tcSelect.currentPage,
          pageSize: this.tcSelect.pageSize,
        },
        "停车报表"
      );
    },
    delRow(row) {
      //删除被点击
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/carSpaceRental/deleteCarSpaceRental", {
              params: {
                id: row.id,
              },
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.getAll();
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    close() {
      //弹框关闭
      this.$refs.form.resetFields();
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    getAll() {
      //获取表格数据
      //   this.loading = true;
      this.$http
        .post("/api/bdTingCheOrder/getTingcheStatement", {
          startTime: this.dateArr[0],
          endTime: this.dateArr[1],
          currentPage: this.tcSelect.currentPage,
          pageSize: this.tcSelect.pageSize,
        })
        .then((res) => {
          //   this.loading = false;
          if (res.data.code == 0) {
            this.tcList = res.data.data.items;
            this.sjSumAmount = res.data.data.map.sjSumAmount;
            this.tingcheAmount = res.data.data.map.tingcheAmount;
            this.totalNum = res.data.data.totalNum;
          } else {
            this.tcList = [];
            this.totalNum = 0;
          }
        });
    },
    query() {
      this.tcSelect.currentPage = 1;
      this.getAll();
    },
    sizeChange(size) {
      //页大小被修改
      this.tcSelect.pageSize = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.tcSelect.currentPage = page;
      this.getAll();
    },
  },
  mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.dateArr = [
      start.getFullYear() +
        "-" +
        (start.getMonth() + 1 < 10
          ? "0" + (start.getMonth() + 1)
          : start.getMonth() + 1) +
        "-" +
        (start.getDate() < 10 ? "0" + start.getDate() : start.getDate()),
      end.getFullYear() +
        "-" +
        (end.getMonth() + 1 < 10 ? "0" + (end.getMonth() + 1) : end.getMonth() + 1) +
        "-" +
        (end.getDate() < 10 ? "0" + end.getDate() : end.getDate()),
    ];
    this.getAll();
  },
};
</script>

<style></style>
